import { createApiRef } from '@backstage/core-plugin-api';










/**
 * ApiRef for the AgentApi.
 *
 * @public
 */
export const agentApiRef = createApiRef({
  id: 'plugin.agent.api',
});

export const bitbucketWorkspaceURL = 'https://bitbucket.org/accelbyte';













































































